export const CONTACT_ATTACHMENT_MAX_COUNT = 3;
export const CONTACT_ATTACHMENT_MAX_BYTES = 5 * 1024 * 1024;
export const CONTACT_ATTACHMENT_ACCEPTED_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;

export const CONTACT_ATTACHMENT_ACCEPTED_LABELS = ['JPG', 'PNG', 'WEBP'];
